import { useAutoLogout } from './use-auto-logout';

export const AutoLogout = () => {
    useAutoLogout();
    return null;
};

export default AutoLogout;
